import React, { useEffect, useState } from "react";
import { TelerikReportViewer } from "@progress/telerik-react-report-viewer";
import { Grid } from "@mui/material";
import { MainLeftTitle } from "../../_uiComponents/WrapperComponents";
import UiSelect from "../../_uiComponents/common/form/UiSelectDefault";
import { KENDO_REPORTING_URL } from "../../../_redux/_constants/common.constants";
import Cookies from "js-cookie";

export default function Reports(props) {
    const authToken = Cookies.get("auth_token");

    // Make sure the token exists before rendering the viewer
    if (!authToken) {
        return <div>Authorization token is missing!</div>;
    }

    const [initialReport, setInitialReport] = useState("EquipeSignUpReport.trdp");

    const options = [
        { value: "EquipeSignUpReport.trdp", label: "Equipe Sign Up Report" },
        { value: "TLCSignUpReport.trdp", label: "TLC Sign Up Report" },
        { value: "WareAndTear2025Report.trdp", label: "Ware & Tear Target Achievement Report" },
        { value: "CastrolSpinDealerReport.trdp", label: "Castrol WINsdays Code Issuance Report" },
        { value: "CastrolSpinGameWinReport.trdp", label: "Castrol WINsdays Winners Report" },
        { value: "PointsEarnedSpentReport.trdp", label: "Points Earned & Spent Summary Report" },
        { value: "PointsSpentDetailReport.trdp", label: "Points Spent Detail Report" },
        { value: "TLCSignupPayment2024.trdp", label: "TLC Sign up & Payment 2024 Report" },
        { value: "TLCSignupPayment2025.trdp", label: "TLC Sign up & Payment 2025 Report" },
        { value: "TLCSalesVsTarget.trdp", label: "TLC Sales vs Target Report" },
    ];

    return (
        <>
            <MainLeftTitle title="Management Reports" />
            <Grid container spacing={2}>
                <Grid item xs="12" lg="4" sx={{ mt: 2 }}>
                    <UiSelect
                        name="activationSummary"
                        label="Select Report"
                        value={initialReport}
                        options={options}
                        handleChange={(value) => setInitialReport(value)}
                    />
                </Grid>
            </Grid>
            <TelerikReportViewer
                    key={initialReport}
                    reportServer={{
                         url: KENDO_REPORTING_URL,
                    }}
                    reportSource={{
                         report: initialReport,
                         parameters: {},
                    }}
                    authenticationToken={`${authToken}`}
                    serviceUrl={KENDO_REPORTING_URL}
                    viewMode="INTERACTIVE"
                    scaleMode="SPECIFIC"
                    scale={1.0}
                    enableAccessibility={false}
               />


        </>
    );
}
